import React from "react";
import clsx from "clsx";
import styles from "./Heading.module.scss";

export type IHeading = React.HTMLAttributes<HTMLHeadingElement> & {
  level: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "base" | "small" | "large";
  weight?: "regular" | "medium" | "bold";
  margin?: "top" | "bottom" | "top-and-bottom";
};

const HeadingElement = ({
  level,
  children,
  ...props
}: {
  level: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
} & React.HTMLAttributes<HTMLHeadingElement>) => {
  const htmlElement = level;
  return React.createElement(htmlElement, props, children);
};
export const Heading = ({
  level,
  size = level,
  weight = "bold",
  margin,
  children,
  ...props
}: IHeading) => {
  return (
    <HeadingElement
      level={level}
      {...props}
      className={clsx(
        styles[size],
        styles[`weight-${weight}`],
        margin && styles[`margin-${margin}`],
        props.className,
      )}
    >
      {children}
    </HeadingElement>
  );
};

export const HeadingWithEllipsis = ({
  level,
  size = level,
  weight = "bold",
  margin,
  children,
  maxWidth,
  ...props
}: IHeading & {
  maxWidth:
    | `${number}${"px" | "em" | "rem" | "%" | "vw" | "vh" | "ch"}`
    | "unset";
}) => {
  return (
    <Heading
      level={level}
      size={size}
      weight={weight}
      margin={margin}
      {...props}
      className={styles.ellipsis}
      style={{
        maxWidth,
        ...props.style,
      }}
    >
      {children}
    </Heading>
  );
};
